import { NonEmptyArray } from '@appTypes/common/NonEmptyArray';

export const omitNullish = <T extends Record<string, unknown>>(obj: T) =>
  Object.fromEntries(
    Object.entries(obj).filter(([, v]) => v != null),
  ) as Partial<T>;

export const omitEmptyArrays = <T extends Record<string, unknown>>(obj: T) =>
  Object.fromEntries(
    Object.entries(obj).filter(([, v]) => {
      if (v == null) return false;
      if (Array.isArray(v)) return v.length > 0;
      return true;
    }),
  ) as {
    [K in keyof T as T[K] extends [] | null | undefined
      ? never
      : K]: T[K] extends (infer U)[] ? NonEmptyArray<U> : T[K];
  };

export const omitUndefinedNullables = <T extends Record<string, unknown>>(
  obj: T,
) =>
  Object.fromEntries(
    Object.entries(obj).filter(([, v]) => v !== undefined),
  ) as Partial<T>;
